'use client';

import { useLayoutEffect, useState } from 'react';

/**
 * Prevents entry animations on first paint and route changes.
 * The transition is re-enabled after the new route has painted.
 */
export function useRouteTransitionReady(routeKey: string) {
    const [isTransitionReady, setIsTransitionReady] = useState(false);

    useLayoutEffect(() => {
        let firstFrame = 0;
        let secondFrame = 0;

        setIsTransitionReady(false);

        firstFrame = window.requestAnimationFrame(() => {
            secondFrame = window.requestAnimationFrame(() => {
                setIsTransitionReady(true);
            });
        });

        return () => {
            window.cancelAnimationFrame(firstFrame);
            window.cancelAnimationFrame(secondFrame);
        };
    }, [routeKey]);

    return isTransitionReady;
}
